import { forwardRef } from "react";
import { cn } from "../../lib/cn.js";
import { cardVariants } from "../../lib/variants.js";

const Card = forwardRef(
  (
    {
      className,
      variant = "default",
      children,
      ...props
    },
    ref
  ) => {
    const baseClasses = "rounded-2xl";
    const variantClasses = cardVariants.variant[variant] || cardVariants.variant.default;
    
    return (
      <div
        ref={ref}
        className={cn(
          baseClasses,
          variantClasses,
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = "Card";

const CardHeader = forwardRef(
  ({ className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("px-5 pt-5 pb-3", className)}
      {...props}
    >
      {children}
    </div>
  )
);

CardHeader.displayName = "CardHeader";

const CardTitle = forwardRef(
  ({ className, children, ...props }, ref) => (
    <h3
      ref={ref}
      className={cn("font-heading text-lg font-bold text-[var(--color-warm-900)]", className)}
      {...props}
    >
      {children}
    </h3>
  )
);

CardTitle.displayName = "CardTitle";

const CardContent = forwardRef(
  ({ className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("px-5 py-3", className)}
      {...props}
    >
      {children}
    </div>
  )
);

CardContent.displayName = "CardContent";

const CardFooter = forwardRef(
  ({ className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("px-5 pt-3 pb-5", className)}
      {...props}
    >
      {children}
    </div>
  )
);

CardFooter.displayName = "CardFooter";

export { Card, CardHeader, CardTitle, CardContent, CardFooter };
export default Card;